import React from 'react';
import ReactDOM from 'react-dom';

import ImpossiblePanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createImpossibleScreen = ({ loginLink }) => {
  const domId = 'impossiblePanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <AuthScreenLayout>
        <ImpossiblePanel loginLink={loginLink} />
      </AuthScreenLayout>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createImpossibleScreen = createImpossibleScreen;
